import { Injectable } from '@angular/core';
import { CanMatch, Route, UrlSegment, UrlTree } from '@angular/router';
import { Observable, map, tap} from 'rxjs';
import { UserService } from '../services/user.service';

@Injectable({
  providedIn: 'root'
})
export class DashbordGuard implements CanMatch{
  constructor(private userService:UserService){}

  canMatch(
    route: Route,
    segments: UrlSegment[]): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const accesRole:any = route.data
      return this.userService.getUserRole$.pipe(
        tap(res => console.log('DashbordGuard::canMatch', res)),
        map(role => role === accesRole?.role));

  }

}
